<script>
  import { useForm } from '@inertiajs/svelte';
  import AppLayout from '../../components/AppLayout.svelte';
  import Card from '../../components/ui/Card.svelte';
  import Button from '../../components/ui/Button.svelte';

  let { session_token, network, pages = [] } = $props();

  const form = useForm(() => ({
    session_token,
    selected_page_ids: pages.length === 1 ? [pages[0].id] : [],
  }));

  function toggle(id) {
    const set = new Set(form.selected_page_ids);
    if (set.has(id)) set.delete(id); else set.add(id);
    form.selected_page_ids = [...set];
  }

  function submit() {
    form.post('/social_accounts/finalize');
  }
</script>

<AppLayout title="Choose accounts to connect">
  <div class="max-w-md">
    <Card>
      <p class="text-sm text-secondary-500 mb-6 capitalize">
        Choose which {network} pages or profiles to connect.
      </p>
      <form onsubmit={(e) => { e.preventDefault(); submit(); }} class="flex flex-col gap-4">
        {#if form.errors.base}
          <div class="rounded-xl border border-red-200 bg-red-50 text-red-700 px-4 py-3 text-sm">
            {form.errors.base}
          </div>
        {/if}
        <ul class="flex flex-col gap-2">
          {#each pages as page}
            <li>
              <label class="flex items-center gap-3 rounded-xl border border-secondary-200 px-4 py-3 cursor-pointer">
                <input
                  type="checkbox"
                  checked={form.selected_page_ids.includes(page.id)}
                  onchange={() => toggle(page.id)}
                />
                {#if page.profilePictureUrl}
                  <img src={page.profilePictureUrl} alt="" class="w-8 h-8 rounded-full object-cover" />
                {/if}
                <div>
                  <div class="font-semibold text-secondary-800">{page.name}</div>
                  <div class="text-sm text-secondary-500">@{page.username} · {page.type}</div>
                </div>
              </label>
            </li>
          {/each}
        </ul>
        <div class="flex items-center gap-3 mt-2">
          <Button type="submit" disabled={form.processing || form.selected_page_ids.length === 0}>
            {form.processing ? 'Connecting…' : 'Connect selected'}
          </Button>
          <Button href="/social_accounts" variant="ghost">Cancel</Button>
        </div>
      </form>
    </Card>
  </div>
</AppLayout>
